import { render, staticRenderFns } from "./ModeSelector.vue?vue&type=template&id=25d1fea4&scoped=true&"
import script from "./ModeSelector.vue?vue&type=script&lang=ts&"
export * from "./ModeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ModeSelector.vue?vue&type=style&index=0&id=25d1fea4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d1fea4",
  null
  
)

export default component.exports